import { TPanoramaVm } from "..";

export const PanoramaVm: TPanoramaVm = {
  phase: {
    position: [-3051676.982466365, 4040969.0417857477, 3865328.774857175],
    orientation: {
      heading: 1.0234253875925443,
      pitch: -0.6210454884469185,
      roll: 0.000013225861872356859,
    },
  },
  //   baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/3d-tiles-merged/2024/tileset.json`,
  baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL}/models/Manual/K-HQ/tileset.json`,
  items: [
    {
      index: 1,
      position: [127.052899, 37.5404523, 105.5],
      view: {
        position: [127.0534805, 37.5395436, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_1.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_1_1080p.jpg`,
    },
    {
      index: 2,
      position: [127.0528619, 37.5403614, 105],
      view: {
        position: [127.0533372, 37.5395817, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_2.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_2_1080p.jpg`,
    },
    {
      index: 3,
      position: [127.0527588, 37.5401092, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_3.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_3_1080p.jpg`,

      view: {
        position: [127.0536204, 37.5398859, 140],
        orientation: {
          heading: 290,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 4,
      position: [127.0526567, 37.5398594, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_4.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_4_1080p.jpg`,

      view: {
        position: [127.0536496, 37.5402577, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 5,
      position: [127.0526196, 37.5397659, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_5.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_5_1080p.jpg`,

      view: {
        position: [127.0537596, 37.5402292, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 6,
      position: [127.0527435, 37.5397356, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_6.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_6_1080p.jpg`,

      view: {
        position: [127.0537265, 37.5401481, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 7,
      position: [127.0530487, 37.5396556, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_7.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_7_1080p.jpg`,

      view: {
        position: [127.0533291, 37.5403417, 140],
        orientation: {
          heading: 200,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 8,
      position: [127.0533372, 37.5395817, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_8.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_8_1080p.jpg`,

      view: {
        position: [127.0528619, 37.5403614, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 9,
      position: [127.0534805, 37.5395436, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_9.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_9_1080p.jpg`,

      view: {
        position: [127.052899, 37.5404523, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 10,
      position: [127.0535255, 37.5396566, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_10.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_10_1080p.jpg`,

      view: {
        position: [127.0530423, 37.5404142, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 11,
      position: [127.0536204, 37.5398859, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_11.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_11_1080p.jpg`,

      view: {
        position: [127.0527588, 37.5401092, 140],
        orientation: {
          heading: 110,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 12,
      position: [127.0537265, 37.5401481, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_12_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_12.JPG`,

      view: {
        position: [127.0527435, 37.5397356, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 13,
      position: [127.0537596, 37.5402292, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_13_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_13.JPG`,

      view: {
        position: [127.0526196, 37.5397659, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 14,
      position: [127.0536496, 37.5402577, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_14_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_14.JPG`,

      view: {
        position: [127.0526567, 37.5398594, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 15,
      position: [127.0533291, 37.5403417, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_15_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_15.JPG`,

      view: {
        position: [127.0530487, 37.5396556, 140],
        orientation: {
          heading: 15,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 16,
      position: [127.0530423, 37.5404142, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_16_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_16.JPG`,

      view: {
        position: [127.0535255, 37.5396566, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 17,
      position: [127.0531896, 37.5399975, 150],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_17_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_17.JPG`,

      view: {
        position: [127.0535552, 37.5408807, 165],
        orientation: {
          heading: 200,
          pitch: -13,
          roll: 0,
        },
      },
    },


    {
      index: 18,
      // position: [127.052899, 37.5404523, 105.5],
      position: [127.062376, 37.5422839, 100.0],
      view: {
        // position: [127.0534805, 37.5395436, 140],
        position: [127.0655187, 37.5447434, 200],
        orientation: {
          heading: 230.0,
          pitch: -15.0,
          roll: 0.0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_1.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_1.jpg`,
    },
    {
      index: 19,
      // position: [127.0528619, 37.5403614, 105],
      position: [127.0628652, 37.542346, 50.0],
      view: {
        position: [127.0618053, 37.5422044, 60],
        orientation: {
          heading: 77.5,
          pitch: -15.0,
          roll: 0.0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_2.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_2.jpg`,
    },
    {
      index: 20,
      position: [127.0624495, 37.5424702, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_3.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_3.jpg`,
      view: {
        position: [127.0621704, 37.5417802, 60],
        orientation: {
          heading: 22.5,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 21,
      position: [127.062049, 37.5425918, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_4.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_4.jpg`,
      view: {
        position: [127.0627162, 37.541922, 60],
        orientation: {
          heading: -32.5,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 22,
      position: [127.061864, 37.5422091, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_5.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_5.jpg`,
      view: {
        // 5
        position: [127.0629265, 37.5423544, 60],
        orientation: {
          heading: 260.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 23,
      position: [127.0622822, 37.5420849, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_6.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_6.jpg`,
      view: {
        position: [127.0625792, 37.5427845, 60],
        orientation: {
          heading: 200.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 24,
      position: [127.0626802, 37.5419632, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_7.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_7.jpg`,
      view: {
        position: [127.062005, 37.5426309, 60],
        orientation: {
          heading: 140.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },


  ],
};

export default { PanoramaVm };
